<script>
    import R, {LOADER} from "../../lib/requests";
    import {replaceSymbols, setFocusTo} from "../../lib/lib";
    import Notifier from "../../stores/notifier";
    import Modal from '../../components/modal/Modal.svelte';
    import AnalysisAutocompleteControl from "../../components/controls/AnalysisAutocompleteControl.svelte";
    import Checkbox from "../../components/controls/Checkbox.svelte";

    export let analysisId = null;
    export let closeCallback;

    let analysis = null;
    let oldValues = '';
    let enableUpdateCheckbox = false;

    const initialize = () => {
        if (analysisId == 0) {
            analysis = {
                id: 0,
                code: '',
                parameter: '',
                method: '',
                units: '',
                material_category: '',
                material: '',
                upper_limits: '',
                indicative_limits: '',
                comments: '',
                legislation: '',
            }
            setFocusTo('parameter');
        } else {
            load();
        }
    }

    const importantValues = () => {
        return `${analysis.method}|${analysis.units}|${analysis.legislation}`;
    }

    const load = () => {

        const onSuccess = result => {
            analysis = result;
            oldValues = importantValues();
            setFocusTo('parameter');
        };

        const onFailure = err => {
        };

        R.handle(R.analyses.details, analysisId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Η ομάδα αναλύσεων ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {
            if (err.code && err.code === 'same_object_identifier') {
                Notifier.showError("Υπάρχει ήδη ανάλυση με αυτό τον κωδικό!");
                setFocusTo("code");
            }
        };


        analysis.name_el = analysis.name_el.trim();

        if (!analysis.name_el) {
            Notifier.showError("Πληκτρολογήστε την αναλυόμενη παράμετρο");
            setFocusTo("parameter");
            return;
        }

        let action = analysisId == 0 ? 'create' : 'edit';
        R.handle(R.analyses[action], analysis, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        analysis = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const upperLimitsChange = (event) => {
        analysis.upper_limits = replaceSymbols(analysis.upper_limits);
    }

    initialize();

    $: if (analysis) {
        enableUpdateCheckbox = oldValues != importantValues();
    }
</script>

{#if analysis}
    <Modal title="Στοιχεία ανάλυσης" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Κωδικός</label>
                <input type="text" class="form-control" id="code" bind:value="{ analysis.code }"
                       placeholder="κενό για αυτόματο">
            </div>
            <div class="form-group">
                <label>Παράμετρος</label>
                <div class="form-item mb-2">
                    <input type="text" class="form-control" id="parameter" bind:value="{ analysis.name_el }">
                    <div class="form-item-info top">Ελληνικά</div>
                </div>
                <div class="form-item">
                    <input type="text" class="form-control" bind:value="{ analysis.name_en }">
                    <div class="form-item-info top">Αγγλικά</div>
                </div>
            </div>
            <div class="form-group">
                <label>Μεθοδολογία</label>
                <AnalysisAutocompleteControl id="method" field="method" bind:value="{ analysis.method }"/>
            </div>
            <div class="form-group">
                <label>Μονάδες</label>
                <input type="text" class="form-control" bind:value="{ analysis.units }">
            </div>
            <div class="form-group">
                <label>Κατηγορία υλικού</label>
                <AnalysisAutocompleteControl id="materialCategory" field="material_category"
                                             bind:value="{ analysis.material_category }"/>
            </div>
            <div class="form-group">
                <label>Εξεταζόμενο υλικό</label>
                <AnalysisAutocompleteControl id="material" field="material" bind:value="{ analysis.material }"/>
            </div>
            <div class="form-group">
                <label>Ανώτατα όρια</label>
                <input type="text" class="form-control" bind:value="{ analysis.upper_limits }"
                       on:change={ upperLimitsChange }>
            </div>
            <div class="form-group">
                <label>Ενδεικτικά όρια</label>
                <input type="text" class="form-control" bind:value="{ analysis.indicative_limits }">
            </div>
            <div class="form-group">
                <label>Σχόλια</label>
                <input type="text" class="form-control" bind:value="{ analysis.comments }">
            </div>
            <div class="form-group">
                <label>Νομοθεσία</label>
                <AnalysisAutocompleteControl id="legislation" field="legislation" bind:value="{ analysis.legislation }"
                                             top/>
            </div>
            {#if analysis.id > 0}
                <div class="form-group">
                    <Checkbox label="Ενημέρωση Μεθοδολογίας, Μονάδων και Νομοθεσίας στα δείγματα"
                              bind:checked={analysis.update_samples} disabled={!enableUpdateCheckbox}/>
                </div>
            {/if}
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}